<template>
  <div class="d-flex flex-column justify-center text-center">
    <v-badge bordered bottom right overlap color="secondary" offset-x="16" offset-y="16">
      <template #badge>
        <span class="monospace-pure">{{count.toString()}}</span>
      </template>
      <div>
        <figure
          v-if="item.itemId !== 'furni' && item.spriteCoord"
          class="item-icon--sprite"
          :alt="item.name"
          :style="style"
        />
        <v-icon
          v-else-if="item.itemId === 'furni'"
          :class="furniturePadding"
          class="deep-orange item-icon--special white--text"
          :size="24 * ratio"
        >
          mdi-lamp
        </v-icon>
        <v-icon
          v-else-if="item.itemId !== 'furni' && !item.spriteCoord"
          :class="furniturePadding"
          class="blue item-icon--special white--text"
          :size="24 * ratio"
        >
          mdi-treasure-chest
        </v-icon>
      </div>
    </v-badge>
    <div class="caption">
      <span>{{item.name}}</span>&nbsp;
      <span class="monospace-pure">{{item.itemId}}</span>
      <br>
      <span>置信</span>&nbsp;
      <span class="monospace-pure">{{ (confidence * 100).toFixed(3) }}%</span>
    </div>
  </div>
</template>

<script>
import pdata from '@/models/pdata'

export default {
  name: 'Item',
  props: {
    itemId: {
      type: String,
      required: true
    },
    ratio: {
      type: Number,
      default () {
        return 1
      }
    },
    count: {
      type: Number,
      default () {
        return 0
      }
    },
    confidence: {
      type: Number,
      default () {
        return -1
      }
    }
  },
  data () {
    return {
      previousIconSize: 60,
      resolutions: {
        high: {
          iconSize: 183,
          dimensions: [1098, 2562],
          url: 'https://penguin.upyun.galvincdn.com/sprite/sprite.202011011235.png'
        },
        low: {
          iconSize: 183 / 2,
          dimensions: [1098 / 2, 2562 / 2],
          url: 'https://penguin.upyun.galvincdn.com/sprite/sprite.202011011235.small.png'
        }
      }
    }
  },
  computed: {
    item () {
      return pdata.item.byItemId(this.itemId)
    },
    furniturePadding () {
      if (this.ratio <= 0.25) {
        return ['pa-0']
      } else if (this.ratio <= 0.5) {
        return ['pa-1']
      } else if (this.ratio <= 0.75) {
        return ['pa-2']
      } else if (this.ratio <= 1) {
        return ['pa-3']
      } else {
        return ['pa-5']
      }
    },
    lowResolution () {
      let lowResolution = true
      if (window.matchMedia) {
        if (window.devicePixelRatio >= 2 || window.matchMedia('(min-resolution: 192dpi)').matches) { lowResolution = false }
      }
      return lowResolution
    },
    current () {
      return this.resolutions[this.lowResolution ? 'low' : 'high']
    },
    config () {
      const zoom = this.ratio * (this.previousIconSize / this.current.iconSize)
      return {
        iconSize: zoom * this.current.iconSize,
        url: this.current.url,
        zoom
      }
    },
    style () {
      const style = {
        height: `${this.config.iconSize}px`,
        width: `${this.config.iconSize}px`,
        backgroundSize: `${this.config.zoom * this.current.dimensions[0]}px ${this.config.zoom * this.current.dimensions[1]}px`,
        backgroundImage: `url(${this.config.url})`
      }
      if (this.item.spriteCoord) {
        style.backgroundPosition = this.transformCoordinate(this.item.spriteCoord)
      }
      return style
    }
  },
  methods: {
    transformCoordinate (coordinate) {
      const factorized = this.config.iconSize
      return `-${coordinate[0] * factorized}px -${coordinate[1] * factorized}px`
    }
  }
}
</script>

<style scoped>
.item-icon--sprite {
  background-repeat: no-repeat;
  height: 60px;
  width: 60px;
  display: inline-block;
  overflow: hidden;
  transition: transform 150ms cubic-bezier(.25,.8,.5,1);

  transform-origin: center center;
}

.item-icon--sprite--disable-hover-effect {
  transform: none !important;
}

.item-icon--special {
  border-radius: 50%;
  /*margin: 0 .2rem;*/
}
</style>
